import FileDropzone from 'emerald-ui/lib/FileDropzone';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: FileDropzone, componentName: 'FileDropzone' }], 'FileDropzone'),
  description:
    'An area that can receive dragged files and reports back which files were accepted based on some defined properties.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FileDropzone },
      whiteBackground: true,
      code: `<FileDropzone aria-label="Click to upload a file" />`,
    },
  ],
};
